import { Autocomplete } from "@/components/atoms";
import { AutocompleteOption } from "@/components/atoms/Autocomplete";
import { useEducations } from "@/hooks";
import { Education } from "@/types/jobPost";
import { UserEducation } from "@/types/user";
import { useEffect, useRef } from "react";

export interface UserEducationDropdownProps {
  userEducations: UserEducation[];
  selectedEducations: Education[];
  setSelectedEducations: (selectedEducations: Education[]) => void;
}

export const UserEducationDropdown = ({
  userEducations,
  selectedEducations,
  setSelectedEducations,
}: UserEducationDropdownProps) => {
  const { educations, loading: educationsLoading } = useEducations();

  const hasInitialized = useRef(false);

  // Sync selectedEducations with userEducations initially
  useEffect(() => {
    if (
      !hasInitialized.current &&
      !selectedEducations?.length &&
      userEducations?.length
    ) {
      const initial = userEducations.map(ue => ue.education);
      setSelectedEducations(initial);
      hasInitialized.current = true;
    }
  }, [userEducations, selectedEducations, setSelectedEducations]);

  const options: AutocompleteOption[] =
    educations?.map(education => ({
      key: education.id,
      value: education.education_name,
      display: `${education.education_name} (${education.education_code})`,
    })) || [];

  const selectedOptions: AutocompleteOption[] =
    selectedEducations?.map(education => ({
      key: education.id,
      value: education.education_name,
      display: `${education.education_name} (${education.education_code})`,
    })) || [];

  return (
    <Autocomplete
      componentName={"educations"}
      multiple
      inputLabel="Educations"
      options={options}
      value={selectedOptions}
      onChange={(_, value) => {
        const selectedValues = (value as AutocompleteOption[]).filter(Boolean);

        const selected = educations?.filter(education =>
          selectedValues.some(el => el.key === education.id),
        );

        if (selected) {
          setSelectedEducations(selected);
        }
      }}
      loading={educationsLoading}
      disableClearable
      renderCheckMarks
    />
  );
};
